import React, {useEffect, useRef, useState} from "react";
import {
    IonBackdrop,
    IonButton, IonCheckbox,
    IonCol,
    IonContent, IonGrid,
    IonHeader, IonIcon, IonInput,
    IonItem,
    IonLabel, IonModal,
    IonRow,
    IonTabButton, IonTitle, IonToast,
    IonToolbar
} from "@ionic/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Text from "../CommonStyles/Text";
import "./iframe.css"
import axios from "axios";
import styled from "@emotion/styled";
import './index.css';
import {useNavigate} from "react-router-dom";
import CheckBox from "../../components/CheckBox/Index"
import {OverlayEventDetail} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import CurrencyInput from "react-currency-input-field";
import store from "../../redux/store";
import {cartOutline, create, createOutline, chevronDownOutline, chevronUpOutline, checkmarkOutline} from "ionicons/icons";
import {getConfig} from "../../AppConfig";

const PURPLE = '#5b21b6';

const Span = styled.span`
  padding-left: 0.5em;
`

const SpanImage = styled.span`
  margin-top: 5px;
`

const Image = styled.img`
  height: 30px;
`

const ModalContent = styled.div`
  margin-top: 32px;
  margin-left: 32px;
  margin-right: 32px;
  height: 32em;
  text-align: left;
  h1 {
    font-family: var(--ion-font-family);
    font-size: 33px;
    font-weight: bold;
    text-align: center;
  }
  h2 {
    font-family: var(--ion-font-family);
    font-size: 26px;
    text-align: center;
  }
  p {
    font-family: var(--ion-font-family);
  }
  letter-spacing: 0px;
  color: #333333;
`

export const Input = styled("input")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 44px;
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  outline: none;
  border: 1px solid #d1d5db;
  padding-left: 12px;
  font-size: 15px;
  ::placeholder {
    font-size: 14px;
    color: #9ca3af;
    padding-left: 0;
  }
  :disabled {
    color: #8a8a8a;
    background-color: #f9fafb;
  }
`;

const Select = styled("select")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 44px;
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  outline: none;
  border: 1px solid #d1d5db;
  padding-left: 12px;
  font-size: 15px;
  cursor: pointer;
  :disabled {
    color: #8a8a8a;
    background-color: #f9fafb;
  }
`

const Option = styled("option")`
  box-sizing: border-box;
  background-color: #ffffff;
  outline: none;
  border: none;
`

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
`

const ConfirmationBanner = styled.div`
  border: 1px solid ${PURPLE};
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  background-color: #faf5ff;
  color: #374151;
`

const PageHeading = styled.h1`
  font-size: 28px;
  font-weight: 800;
  color: #111827;
  margin: 16px 16px 8px;
  padding: 0;
  font-family: var(--ion-font-family);
`

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 16px 16px;
  padding: 0;
  line-height: 1.5;
`

const ProgressCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px 16px;
  margin: 0 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #374151;
  background-color: #ffffff;
`

const ProgressCount = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${PURPLE};
`

const GroupSectionContainer = styled.div`
  margin: 0 16px 24px;
`

const GroupHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`

const GroupTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`

const GroupRegisteredCount = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${PURPLE};
`

const GuestCard = styled.div<{expanded?: boolean}>`
  border: 1.5px solid ${props => props.expanded ? PURPLE : '#e5e7eb'};
  border-radius: 10px;
  margin-bottom: 8px;
  overflow: hidden;
  background-color: #ffffff;
`

const GuestCardHeader = styled.div<{expanded?: boolean}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  background-color: ${props => props.expanded ? '#faf5ff' : '#ffffff'};
`

const GuestCardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const GuestBadge = styled.div<{registered?: boolean}>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${props => props.registered ? '#16a34a' : '#e5e7eb'};
  color: ${props => props.registered ? '#ffffff' : '#6b7280'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
`

const GuestInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const GuestNameText = styled.span<{expanded?: boolean}>`
  font-size: 15px;
  font-weight: ${props => props.expanded ? '600' : '400'};
  color: ${props => props.expanded ? PURPLE : '#374151'};
`

const GuestMealText = styled.span`
  font-size: 12px;
  color: #9ca3af;
  font-weight: 400;
`

const GuestCardBody = styled.div`
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  background-color: #ffffff;
`

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

const FieldLabelText = styled.label`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #374151;
`

const OptionalTag = styled.span`
  font-weight: 400;
  text-transform: none;
  font-size: 11px;
  color: #9ca3af;
  margin-left: 4px;
  letter-spacing: 0;
`

const RequiredStar = styled.span`
  color: #ef4444;
  margin-left: 2px;
`

const SaveRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 12px;
  flex-wrap: wrap;
`

const SaveButton = styled.button<{disabled?: boolean}>`
  background: ${props => props.disabled ? '#e5e7eb' : PURPLE};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.disabled ? '#9ca3af' : '#ffffff'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  padding: 10px 20px;
  font-family: var(--ion-font-family);
  transition: background 0.15s;
  &:hover:not(:disabled) {
    background: #4c1d95;
  }
`

const SkipButton = styled.button`
  background: none;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  padding: 10px 20px;
  font-family: var(--ion-font-family);
  transition: border-color 0.15s, color 0.15s;
  &:hover {
    border-color: #9ca3af;
    color: #374151;
  }
`

const SaveHint = styled.span`
  font-size: 13px;
  color: #9ca3af;
  width: 100%;
`

const ErrorText = styled.span`
  font-size: 12px;
  color: #ef4444;
`


const RegistrationPage = ({storeData, setStoreData, item, eventcode, auctioncode, onRegistrationStatsChange = null, onSkipForNow = null}) => {
    const navigate = useNavigate()
    const [toastState, setToastState] = useState({display: false, goback: false, message: ''})
    const [groupName, setGroupName] = useState('')
    const [groupModal, setGroupModal] = React.useState({active: false, groupName: '', groupId: ""})
    const [messageModal, setMessageModal] = React.useState({active: false, message: '', title: ''})
    const [guestModal, setGuestModal] = React.useState({active: false, groupName: '', guestId: "", guestName: ""})
    const [registrationId, setRegistrationId] = React.useState('')
    const [guestDefaultData, setGuestDefaultData] = React.useState({})
    const [fieldListData, setFieldListData] = React.useState({guestlist: [], guestfieldslist:[], guestlookuplist: [], selectedregistrationid: null})
    const [overrideEdit, setOverrideEdit] = React.useState(true)
    const [currentGuest, setCurrentGuest] = React.useState({guestid: 0})
    const [storeGroups, setStoreGroups] = React.useState([])
    const [groupsLoaded, setGroupsLoaded] = React.useState(false)
    const [savedGuestIds, setSavedGuestIds] = React.useState<Set<number>>(new Set())
    const [skippedGuestIds, setSkippedGuestIds] = React.useState<Set<any>>(new Set())
    const [sessionTouchedIds, setSessionTouchedIds] = React.useState<Set<any>>(new Set())
    const [guestMeals, setGuestMeals] = React.useState<Map<number, string>>(new Map())
    const [errorData, setErrorData] = React.useState([])
    const [expandedGuestId, setExpandedGuestId] = React.useState<number | null>(null)
    const [registrationStats, setRegistrationStats] = React.useState({total: 0, registered: 0})
    const modal = useRef<HTMLIonModalElement>(null)
    const hasPreloaded = useRef(false)
    const hasAutoOpened = useRef(false)
    const { apiUrl } = getConfig()
    const storeguestUrl = `${apiUrl}/storeguest`
    const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


    useEffect(() => {
        if (storeData?.hascheckedout) {
            getStoreGroups()
        }
    }, [storeData])

    useEffect(() => {
        var newValues = {}
        fieldListData.guestfieldslist.map(field => {
            const fieldValue = "fieldvalue" + field.fieldcontrol.toString()
            if  (field.fieldcontrol == 1) {
                newValues[field.fieldid] = field[fieldValue] != null ? field[fieldValue] ? 'Yes' : 'No' : 'No'
            }
            else {
                newValues[field.fieldid] = field[fieldValue] != null ? field[fieldValue] : ''
            }
        })
        setGuestDefaultData(newValues)
    }, [fieldListData.guestfieldslist])

    useEffect(() => {
        if (registrationId === 'add_new') {
            getStoreGuestData(currentGuest.guestid, true)
        }
        else if (registrationId) {
            getStoreGuestData(currentGuest.guestid, false)
        }
    }, [registrationId])

    useEffect(() => {
        var copyDataObject = {...fieldListData}
        const copyGuestFieldsList = fieldListData.guestfieldslist.map(guestFL => {
            var oeOv = guestFL.fieldreadonly
            if (overrideEdit === false) {
                oeOv = false
            }
            return {...guestFL, "overridereadonly": oeOv}
        })
        copyDataObject['guestfieldslist'] = copyGuestFieldsList
        setFieldListData(copyDataObject)
    }, [overrideEdit])

    useEffect(() => {
        if (expandedGuestId === null) {
            setOverrideEdit(true)
            setRegistrationId('')
            setGuestDefaultData({})
            setFieldListData({guestlist: [], guestfieldslist:[], guestlookuplist: [], selectedregistrationid: null})
        }
    }, [expandedGuestId])

    useEffect(() => {
        if (!hasAutoOpened.current && storeGroups.length > 0) {
            hasAutoOpened.current = true
            const firstGroup = storeGroups[0]
            const firstGuest = firstGroup?.guests?.[0]
            if (firstGuest) {
                manageGuest(firstGuest, firstGroup)
            }
        }
    }, [storeGroups])

    useEffect(() => {
        let total = 0
        let registered = 0
        let sessionTouched = 0
        storeGroups.forEach((group: any) => {
            const guests = group.guests || []
            total += guests.length
            guests.forEach((guest: any) => {
                if (savedGuestIds.has(guest.guestid)) registered++
                if (sessionTouchedIds.has(guest.guestid)) sessionTouched++
            })
        })
        if (total > 0 || groupsLoaded) {
            setRegistrationStats({total, registered})
            if (onRegistrationStatsChange) {
                onRegistrationStatsChange({total, registered, skipped: sessionTouched, loaded: groupsLoaded})
            }
        }
    }, [storeGroups, savedGuestIds, sessionTouchedIds, groupsLoaded])

    useEffect(() => {
        setOverrideEdit(true)
        setRegistrationId('')
        setGuestDefaultData({})
        setFieldListData({guestlist: [], guestfieldslist:[], guestlookuplist: [], selectedregistrationid: null})
    }, [guestModal.active === false])

    const checkGuestRegistrationStatus = async (guestid: number, token: string): Promise<{registered: boolean, meal?: string}> => {
        try {
            const {data} = await axios.post(storeguestUrl, {guestid}, {
                headers: {'Authorization': `Bearer ${token}`}
            })
            const parsedData = JSON.parse(data.jsonString)
            if (parsedData.status === 'success') {
                const firstNameField = parsedData.guestfieldslist?.find((f: any) => f.fieldlabel === 'First Name')
                const lastNameField = parsedData.guestfieldslist?.find((f: any) => f.fieldlabel === 'Last Name')
                if (!firstNameField || !lastNameField) return {registered: false}
                const firstName = firstNameField[`fieldvalue${firstNameField.fieldcontrol}`]?.toString().trim()
                const lastName = lastNameField[`fieldvalue${lastNameField.fieldcontrol}`]?.toString().trim()
                const registered = !!(firstName && lastName)

                const mealField = parsedData.guestfieldslist?.find((f: any) => f.fieldlabel?.toLowerCase().includes('meal'))
                let meal = ''
                if (mealField) {
                    const mealValue = mealField[`fieldvalue${mealField.fieldcontrol}`]
                    if (mealValue && String(mealValue) !== '-9000') {
                        const lookupItem = parsedData.guestlookuplist?.find((l: any) =>
                            l.lookupfieldid === mealField.fieldid && String(l.lookupid) === String(mealValue)
                        )
                        meal = lookupItem?.lookup || String(mealValue)
                    }
                }

                return {registered, meal: meal || undefined}
            }
            return {registered: false}
        } catch { return {registered: false} }
    }

    const getStoreGroups = async () => {
        const token = localStorage.getItem('tokenstore')
        const {data} = await axios.get(storeguestUrl, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            const groups = parsedData?.groups || []
            setStoreGroups(groups)
            setGroupsLoaded(true)

            if (!hasPreloaded.current) {
                hasPreloaded.current = true
                const allGuests = groups.flatMap((g: any) => g.guests || [])
                const results: {guestid: number, registered: boolean, meal?: string}[] = await Promise.all(
                    allGuests.map((guest: any) =>
                        checkGuestRegistrationStatus(guest.guestid, token)
                            .then(({registered, meal}) => ({guestid: guest.guestid as number, registered, meal}))
                    )
                )
                setSavedGuestIds(new Set(results.filter(r => r.registered).map(r => r.guestid)))
                setGuestMeals(new Map(results.filter(r => r.meal).map(r => [r.guestid, r.meal!])))
            }
        }
    }

    const getStoreGuestData = async (storeguestid, addNew, explicitRegistrationId?: string) => {
        if (storeguestid) {
            var body: any = {"guestid": storeguestid}
            const regId = explicitRegistrationId !== undefined ? explicitRegistrationId : registrationId

            if (addNew) {
                body['registrationid'] = -1
            }
            else if (Number(regId)) {
                body['registrationid'] = Number(regId)
            }

            const token = localStorage.getItem('tokenstore')
            const {data} = await axios.post(storeguestUrl, body,{headers: {
                    'Authorization': `Bearer ${token}`
                }})
            const parsedData = JSON.parse(data.jsonString)

            if (parsedData.status === 'expired') {
                localStorage.removeItem("tokenstore")
                navigate(`/${eventcode}/event`);
            }
            else if (parsedData.status === 'success') {
                var copyDataObject = {...parsedData}
                const copyGuestFieldsList = parsedData.guestfieldslist.map(guestFL => {
                    return {...guestFL, "overridereadonly": guestFL.fieldreadonly}
                })
                copyDataObject['guestfieldslist'] = copyGuestFieldsList
                setRegistrationId(copyDataObject.selectedregistrationid)
                setFieldListData(copyDataObject)
            }
        }
    }

    const putStoreGuestData = async (body) => {
        const token = localStorage.getItem('tokenstore')
        const {data} = await axios.put(storeguestUrl, body,{headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            console.log("SUCCESS")
        }
    }

    const renameGroup = (guest) => {
        if (guest.allowchangegroupname) {
            setGroupName(guest.groupname)
            setGroupModal({active: true, groupName: guest.groupname, groupId: guest.groupid})
        }
    }

    const manageGuest = (guest, storeguest) => {
        setCurrentGuest(guest)
        setGuestDefaultData({})
        setFieldListData({guestlist: [], guestfieldslist: [], guestlookuplist: [], selectedregistrationid: null})
        setRegistrationId('')
        setErrorData([])
        getStoreGuestData(guest.guestid, false, '')
        setExpandedGuestId(guest.guestid)
        setGuestModal({active: true, groupName: storeguest?.groupname, guestId: guest.guestid, guestName: guest.guestname})
    }

    const renameGroupText = async () => {
        const body = {
            "groupid": groupModal.groupId,
            "groupname": groupName
        }
        const token = localStorage.getItem('tokenstore')
        const groupRenameUrl = `${apiUrl}/storeguestgroupname`
        const {data} = await axios.put(groupRenameUrl, body, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'failure') {
            setMessageModal({active: true, message: parsedData.message, title: 'Error Saving Group Name'})
        }
        else {
            let storeGuest = storeGroups.find(
                (item) => item.groupid === groupModal.groupId
            )
            storeGuest.groupname = groupName
            setGroupModal({active: false, groupName: '', groupId:''})
        }
    }

    function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
        setGroupModal({active: false, groupName: '', groupId:''})
    }

    const getGroupRenameModal = () => {
        if (groupModal.active) {
            return (
                <>
                    <IonBackdrop visible={groupModal.active}></IonBackdrop>
                    <div id="box" style={{width: '80%', height: '50%', backgroundColor: '#f2f2f2'}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol style={{ display: "flex" }} size="12" className="ion-justify-content-center" >
                                    <div style={{ display: "flex", fontSize: '26px' }}>{"Rename Your Group"}</div>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol style={{display: "flex"}} size="12" className="ion-justify-content-center">
                                    <div>{groupModal.groupName}</div>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonItem lines={'none'}>
                                        <Input
                                            id="group-name"
                                            style={{width: '100%'}}
                                            placeholder={groupModal.groupName}
                                            value={groupName}
                                            onChange={(e) => {
                                                setGroupName(e.target.value)
                                            }}
                                        />
                                    </IonItem>
                                </IonCol>
                            </IonRow>
                            <IonRow style={{marginBottom: '20px'}}>
                                <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                                    <IonButton onClick={() => { setGroupModal({active: false, groupName: '', groupId:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                        Cancel
                                    </IonButton>
                                </IonCol>
                                <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                                    <IonButton onClick={() => { renameGroupText() }} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                        Save
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                </>
            )
        }
        return <></>
    }

    const getMessageModal = () => {
        if (messageModal.active) {
            return (
                <>
                    <IonBackdrop visible={messageModal.active}></IonBackdrop>
                    <div id="box" style={{width: '50%', height: '30%', backgroundColor: '#f2f2f2'}}>
                        <IonGrid>
                            <IonRow style={{marginBottom: '20px'}}>
                                <IonCol style={{ display: "flex" }} size="12" className="ion-justify-content-center" >
                                    <div style={{ display: "flex", fontSize: '26px', color: 'red' }}>{messageModal.title}</div>
                                </IonCol>
                            </IonRow>
                            <IonRow style={{marginBottom: '20px'}}>
                                <IonCol style={{display: "flex"}} size="12" className="ion-justify-content-center">
                                    <div style={{ display: "flex", fontSize: '18px' }}>{messageModal.message}</div>
                                </IonCol>
                            </IonRow>
                            <IonRow style={{marginBottom: '20px'}}>
                                <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                                    <IonButton onClick={() => { setMessageModal({active: false, message: '', title: ''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                        Ok
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                </>
            )
        }
        return <></>
    }

    const getFieldOptions = (guestData) => {
        var options = [
            <Option value={-9000} key={-9000}>
                None
            </Option>
        ]

        if (fieldListData && fieldListData?.guestlookuplist && fieldListData?.guestlookuplist.length > 0) {
            const filteredOptions = fieldListData?.guestlookuplist?.filter(guests => guests.lookupfieldid === guestData.fieldid)
            if (filteredOptions && filteredOptions.length > 0) {
                const newoptions = filteredOptions.map((guestListDataOption, index) => {
                    return (
                        <Option value={guestListDataOption?.lookupid} key={index}>
                            {guestListDataOption?.lookup}
                        </Option>
                    )
                })
                options = [...options, ...newoptions]
            }
        }
        return options
    }

    const submitData = async () => {
        setErrorData([])
        var fieldData = []
        var errorArray = []
        var error = false
        fieldListData?.guestfieldslist?.map((guestData) => {
            const fieldValueString = "fieldvalue" + guestData.fieldcontrol
            var dataToAppend = {"fieldid":guestData.fieldid}
            if (guestData.fieldrequired && !guestDefaultData[guestData.fieldid]) {
                errorArray.push({fieldid: guestData.fieldid, message: guestData.fieldlabel + ' is required.'})
                error = true
            }
            if (guestData.fieldlabel === 'Email') {
                if (guestDefaultData[guestData.fieldid]?.length > 0 && !emailRegex.test(guestDefaultData[guestData.fieldid])) {
                    errorArray.push({fieldid: guestData.fieldid, message: guestData.fieldlabel + ' is invalid.'})
                    error = true
                }
            }
            if (guestData.fieldcontrol == 1) {
                dataToAppend[fieldValueString] = guestDefaultData[guestData.fieldid] === 'Yes' ? true : false
                fieldData.push(dataToAppend)
            }
            else if (guestDefaultData[guestData.fieldid]) {
                dataToAppend[fieldValueString] = guestDefaultData[guestData.fieldid]
                fieldData.push(dataToAppend)
            }
        })

        if (!error) {
            var body: any = {"guestfieldslist": fieldData, "guestid": guestModal.guestId}

            if (registrationId !== 'add_new' && Number(registrationId) > 0) {
                body['registrationid'] = Number(registrationId)
            }
            else if (registrationId === 'add_new') {
                body['registrationid'] = -1
            }

            await putStoreGuestData(body)

            const {nextGuest, nextGroup} = findNextGuest(guestModal.guestId)

            const firstNameField = fieldListData.guestfieldslist.find(f => f.fieldlabel === 'First Name')
            const lastNameField = fieldListData.guestfieldslist.find(f => f.fieldlabel === 'Last Name')
            const firstName = firstNameField ? (guestDefaultData[firstNameField.fieldid] || '').toString().trim() : ''
            const lastName = lastNameField ? (guestDefaultData[lastNameField.fieldid] || '').toString().trim() : ''
            if (firstName && lastName) {
                setSavedGuestIds(prev => { const next = new Set(prev); next.add(currentGuest.guestid); return next })
            } else {
                setSavedGuestIds(prev => {
                    const next = new Set(prev)
                    next.delete(currentGuest.guestid)
                    return next
                })
            }
            setSkippedGuestIds(prev => { const next = new Set(prev); next.delete(currentGuest.guestid); return next })
            setSessionTouchedIds(prev => new Set(prev).add(currentGuest.guestid))

            const mealField = fieldListData.guestfieldslist.find(f => f.fieldlabel?.toLowerCase().includes('meal'))
            if (mealField) {
                const mealValue = guestDefaultData[mealField.fieldid]
                if (mealValue && String(mealValue) !== '-9000') {
                    const lookupItem = fieldListData.guestlookuplist?.find((l: any) =>
                        l.lookupfieldid === mealField.fieldid && String(l.lookupid) === String(mealValue)
                    )
                    const mealText = lookupItem?.lookup || String(mealValue)
                    setGuestMeals(prev => new Map(prev).set(currentGuest.guestid, mealText))
                } else {
                    setGuestMeals(prev => { const next = new Map(prev); next.delete(currentGuest.guestid); return next })
                }
            }

            await getStoreGroups()

            if (nextGuest) {
                manageGuest(nextGuest, nextGroup)
            } else {
                setExpandedGuestId(null)
                setGuestModal({active: false, groupName: '', guestId: '', guestName: ''})
            }
        }
        else {
            setErrorData(errorArray)
        }
    }

    const findNextGuest = (currentGuestId: any) => {
        const allGroups = storeGroups as any[]
        for (let gi = 0; gi < allGroups.length; gi++) {
            const guests = allGroups[gi].guests || []
            const currentIdx = guests.findIndex((g: any) => String(g.guestid) === String(currentGuestId))
            if (currentIdx !== -1) {
                if (currentIdx < guests.length - 1) {
                    return {nextGuest: guests[currentIdx + 1], nextGroup: allGroups[gi]}
                }
                for (let gi2 = gi + 1; gi2 < allGroups.length; gi2++) {
                    const nextGroupGuests = allGroups[gi2].guests || []
                    if (nextGroupGuests.length > 0) {
                        return {nextGuest: nextGroupGuests[0], nextGroup: allGroups[gi2]}
                    }
                }
                return {nextGuest: null, nextGroup: null}
            }
        }
        return {nextGuest: null, nextGroup: null}
    }

    const skipGuest = () => {
        setSkippedGuestIds(prev => new Set(prev).add(guestModal.guestId))
        setSessionTouchedIds(prev => new Set(prev).add(guestModal.guestId))
        if (onSkipForNow) {
            onSkipForNow()
        }
        const {nextGuest, nextGroup} = findNextGuest(guestModal.guestId)
        if (nextGuest) {
            manageGuest(nextGuest, nextGroup)
        } else {
            setExpandedGuestId(null)
            setGuestModal({active: false, groupName: '', guestId: '', guestName: ''})
        }
    }

    const updateGuestData = (value, guestData) => {
        const dataObj = guestDefaultData
        var newObject = {...dataObj}
        newObject[guestData.fieldid] = value
        setGuestDefaultData(newObject)

        const item = errorData.find(item => item.fieldid === guestData.fieldid)
        if (item && value) {
            const newError = errorData.filter(removeItem => removeItem.fieldid !== guestData.fieldid)
            setErrorData(newError)
        }
        else if (guestData.fieldrequired && !value) {
            const errorDataCopy = errorData
            errorDataCopy.push({fieldid: guestData.fieldid, message: guestData.fieldlabel + ' is required.'})
            setErrorData(errorDataCopy)
        }
    }

    const isGuestRegistered = (guest: any) => savedGuestIds.has(guest.guestid)

    const getErrorDataObject = (fieldid) => {
        return errorData.find(errorControl5 => errorControl5.fieldid === fieldid)
    }

    const renderField = (guestData) => {
        const errorCheckObj = getErrorDataObject(guestData.fieldid)
        const showEditIcon = guestData.fieldlabel === 'First Name' && fieldListData.selectedregistrationid > 0 && registrationId !== 'add_new'

        const labelEl = (
            <FieldLabelText>
                {guestData.fieldlabel}
                {!!guestData.fieldrequired && <RequiredStar>*</RequiredStar>}
                {showEditIcon && (
                    <IonButton
                        fill="clear"
                        onClick={(e) => { e.stopPropagation(); setOverrideEdit(!overrideEdit) }}
                        style={{margin: '0 0 0 4px', height: '18px', '--padding-start': '2px', '--padding-end': '2px'}}
                    >
                        <IonIcon icon={createOutline} style={{width: 14, height: 14, color: overrideEdit ? "#d00909" : '#59c75e'}} />
                    </IonButton>
                )}
            </FieldLabelText>
        )

        let control = null
        if (guestData.fieldcontrol === 1) {
            control = (
                <Select
                    name={guestData.fieldlabel}
                    id={guestData.fieldid}
                    required={guestData.fieldrequired}
                    value={guestDefaultData[guestData.fieldid]}
                    disabled={guestData.fieldreadonly && guestData.overridereadonly}
                    onChange={(e) => updateGuestData(e.target.value, guestData)}
                >
                    <Option value={'Yes'}>Yes</Option>
                    <Option value={'No'}>No</Option>
                </Select>
            )
        } else if (guestData.fieldcontrol === 2) {
            control = (
                <Select
                    name={guestData.fieldlabel}
                    id={guestData.fieldid}
                    required={guestData.fieldrequired}
                    value={guestDefaultData[guestData.fieldid]}
                    disabled={guestData.fieldreadonly && guestData.overridereadonly}
                    onChange={(e) => updateGuestData(e.target.value, guestData)}
                >
                    {getFieldOptions(guestData)}
                </Select>
            )
        } else if (guestData.fieldcontrol === 3) {
            control = (
                <Input
                    type="number"
                    id={guestData.fieldid}
                    placeholder={guestData.fieldlabel}
                    required={guestData.fieldrequired}
                    readOnly={guestData.fieldreadonly && guestData.overridereadonly}
                    maxLength={guestData.fieldtextlength}
                    value={guestDefaultData[guestData.fieldid]}
                    onChange={(e) => updateGuestData(e.target.value, guestData)}
                    name={guestData.fieldlabel}
                    style={{width: '100%'}}
                />
            )
        } else if (guestData.fieldcontrol === 4) {
            control = (
                <CurrencyInput
                    id={guestData.fieldid}
                    name={guestData.fieldlabel}
                    style={{
                        display: 'flex', justifyContent: 'flex-end', boxSizing: 'border-box',
                        height: '44px', width: '100%', borderRadius: '8px', textAlign: 'right',
                        backgroundColor: '#ffffff', outline: 'none', border: '1px solid #d1d5db',
                        paddingRight: '10px', paddingLeft: '12px', fontSize: '15px'
                    }}
                    placeholder={guestData.fieldlabel}
                    prefix="$"
                    maxLength={guestData.fieldtextlength}
                    value={String(guestDefaultData[guestData.fieldid])}
                    decimalsLimit={2}
                    disabled={guestData.fieldreadonly && guestData.overridereadonly}
                    onValueChange={(value) => updateGuestData(value, guestData)}
                />
            )
        } else if (guestData.fieldcontrol === 5) {
            control = (
                <Input
                    type="text"
                    id={guestData.fieldid}
                    placeholder={guestData.fieldlabel}
                    required={guestData.fieldrequired}
                    readOnly={guestData.fieldreadonly && guestData.overridereadonly}
                    disabled={guestData.fieldreadonly && guestData.overridereadonly}
                    value={guestDefaultData[guestData.fieldid]}
                    onChange={(e) => updateGuestData(e.target.value, guestData)}
                    name={guestData.fieldlabel}
                    style={{width: '100%'}}
                />
            )
        }

        return (
            <FieldWrapper key={guestData.fieldid}>
                {labelEl}
                {control}
                {errorCheckObj && <ErrorText>{errorCheckObj.message}</ErrorText>}
            </FieldWrapper>
        )
    }

    const getGroupItems = () => {
        if (!storeGroups || storeGroups.length === 0) return null

        return storeGroups.map((storeGuest) => {
            if (!storeGuest?.groupname?.length) return null

            const guests = storeGuest.guests || []
            const registeredCount = guests.filter(g => isGuestRegistered(g)).length

            const requiredUnfilled = fieldListData.guestfieldslist
                .filter(f => f.fieldrequired && !guestDefaultData[f.fieldid])
                .map(f => f.fieldlabel)
            const hintText = requiredUnfilled.length > 0
                ? requiredUnfilled.join(' & ') + ' required'
                : ''

            const guestCards = guests.map((guest, index) => {
                const isExpanded = expandedGuestId === guest.guestid
                const displayName = guest.guestname || `Guest ${index + 1}`
                const isLoading = isExpanded && fieldListData.guestfieldslist.length === 0

                return (
                    <GuestCard key={guest.guestid} expanded={isExpanded}>
                        <GuestCardHeader
                            expanded={isExpanded}
                            onClick={() => {
                                if (isExpanded) {
                                    setExpandedGuestId(null)
                                } else {
                                    manageGuest(guest, storeGuest)
                                }
                            }}
                        >
                            <GuestCardHeaderLeft>
                                <GuestBadge registered={isGuestRegistered(guest)}>
                                    {isGuestRegistered(guest)
                                        ? <IonIcon icon={checkmarkOutline} style={{width: 14, height: 14}} />
                                        : index + 1}
                                </GuestBadge>
                                <GuestInfo>
                                    <GuestNameText expanded={isExpanded}>{displayName}</GuestNameText>
                                    {guestMeals.get(guest.guestid) && (
                                        <GuestMealText>{guestMeals.get(guest.guestid)}</GuestMealText>
                                    )}
                                </GuestInfo>
                            </GuestCardHeaderLeft>
                            <IonIcon
                                icon={isExpanded ? chevronUpOutline : chevronDownOutline}
                                style={{color: isExpanded ? PURPLE : '#9ca3af', width: 18, height: 18}}
                            />
                        </GuestCardHeader>

                        {isExpanded && (
                            <GuestCardBody>
                                {fieldListData.guestlist?.length > 0 && (
                                    <div style={{marginBottom: '16px'}}>
                                        <Select
                                            name="guestlist"
                                            style={{width: '100%'}}
                                            value={registrationId}
                                            onChange={(e) => setRegistrationId(e.currentTarget.value)}
                                        >
                                            <Option value={'add_new'}>Add New</Option>
                                            <Option disabled>—————————————</Option>
                                            {fieldListData.guestlist.map((guestItem) => (
                                                <Option key={guestItem.existingguestid} value={guestItem.existingguestid}>
                                                    {guestItem.existingguestname}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                )}

                                {isLoading ? (
                                    <div style={{padding: '20px', textAlign: 'center', color: '#6b7280', fontSize: '14px'}}>Loading...</div>
                                ) : (
                                    <FieldGrid>
                                        {fieldListData.guestfieldslist.map(guestData => renderField(guestData))}
                                    </FieldGrid>
                                )}

                                <SaveRow>
                                    <SaveButton
                                        disabled={errorData?.length > 0}
                                        onClick={submitData}
                                    >
                                        {registrationStats.total === 1 ? 'Save' : 'Save & Next →'}
                                    </SaveButton>
                                    <SkipButton onClick={skipGuest}>
                                        Skip for Now
                                    </SkipButton>
                                    {(hintText || errorData?.length > 0) && (
                                        <SaveHint>
                                            {errorData?.length > 0
                                                ? errorData.map(e => e.message).join(', ')
                                                : hintText}
                                        </SaveHint>
                                    )}
                                </SaveRow>
                            </GuestCardBody>
                        )}
                    </GuestCard>
                )
            })

            return (
                <GroupSectionContainer key={storeGuest.groupid}>
                    <GroupHeaderRow>
                        <GroupTitle>
                            {storeGuest.groupname}
                            {storeGuest.allowchangegroupname && (
                                <IonButton
                                    fill="clear"
                                    style={{margin: 0, height: '22px', '--padding-start': '4px', '--padding-end': '4px'}}
                                    onClick={() => renameGroup(storeGuest)}
                                >
                                    <IonIcon icon={createOutline} style={{width: 15, height: 15, color: '#9ca3af'}} />
                                </IonButton>
                            )}
                        </GroupTitle>
                        <GroupRegisteredCount>
                            {registeredCount} of {guests.length} registered
                        </GroupRegisteredCount>
                    </GroupHeaderRow>
                    {guestCards}
                </GroupSectionContainer>
            )
        })
    }

    return (
        <>
            <IonToast
                isOpen={toastState.display}
                onDidDismiss={() => {
                    if (toastState.goback) {
                        navigate(-1)
                    }
                    setToastState({
                        display: false,
                        goback: false,
                        message: ''
                    })
                }}
                cssClass={'custom-toast'}
                message={toastState.message}
                duration={3000}
            />

            {getGroupRenameModal()}
            {getMessageModal()}

            <PageContainer>
                {storeData?.hascheckedout && (
                    <ConfirmationBanner>
                        <span style={{color: PURPLE, fontWeight: 700, fontSize: 16}}>✓</span>
                        <span>
                            <strong style={{color: PURPLE}}>Payment confirmed!</strong>
                            {' '}A link to this page has been sent to{' '}
                            {storeData?.email
                                ? <strong>{storeData.email}</strong>
                                : 'your email'
                            }.
                        </span>
                    </ConfirmationBanner>
                )}

                {groupsLoaded && storeGroups.some((g: any) => (g.guests?.length ?? 0) > 0) && (
                    <>
                        <PageHeading>Guest Registration</PageHeading>
                        <PageSubtitle>
                            Fill in your guests' information below. You can skip anyone you don't have details for and return later using the link in your email receipt.
                        </PageSubtitle>
                    </>
                )}

                {registrationStats.total > 0 && (
                    <ProgressCard>
                        <span>Overall progress — {registrationStats.total} tickets</span>
                        <ProgressCount>{registrationStats.registered} / {registrationStats.total}</ProgressCount>
                    </ProgressCard>
                )}

                {getGroupItems()}
            </PageContainer>
        </>
    )
}

export default RegistrationPage
